/* ============================================================
   AlienGrafic · Móvil (Plan B)
   Pieza 1: barra + drawer de filtros
   Pieza 2: bottom-sheet de orden
   ------------------------------------------------------------
   El drawer mueve #main-collection-filters adentro al abrir.
   El sheet de orden reusa el <select> nativo #SortBy (le setea
   el valor y dispara 'change'), así el orden se aplica igual
   que en escritorio (nativo, o vía Worker si hay etiqueta).
   ============================================================ */
(function () {
  var MOBILE = 749;
  var aside, placeholder, bar, drawer, body, overlay, closeTimer;
  var sheet, sortOverlay;

  var SORT_OPTIONS = [
    ['best-selling',        'Más vendidos'],
    ['created-descending',  'Novedades'],
    ['price-ascending',     'Precio: menor a mayor'],
    ['price-descending',    'Precio: mayor a menor']
  ];

  function isMobile() { return window.innerWidth <= MOBILE; }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  function init() {
    aside = document.getElementById('main-collection-filters');
    if (!aside) { console.warn('[AlienGrafic] móvil: no encontré #main-collection-filters'); return; }
    buildBar();
    buildDrawer();
    buildSortSheet();
    syncBarTop();
    window.addEventListener('resize', function () { if (!isMobile()) forceClosed(); syncBarTop(); });
    window.addEventListener('load', syncBarTop);

    // "Eliminar todos": forzar navegación a la URL limpia (Dawn lo intercepta por AJAX)
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.active-facets__button-remove');
      if (!a || !a.getAttribute('href')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = a.getAttribute('href');
    }, true);

    console.log('[AlienGrafic] móvil listo');
  }

  /* ── Barra superior ────────────────────────────────────── */
  function buildBar() {
    bar = document.createElement('div');
    bar.className = 'ag-mobile-bar';
    bar.innerHTML =
      '<button type="button" class="ag-mbar-btn" id="agOpenFilters">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/></svg>' +
        'Filtros</button>' +
      '<button type="button" class="ag-mbar-btn" id="agOpenSort">Ordenar por' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg></button>';
    aside.parentNode.insertBefore(bar, aside);
    document.getElementById('agOpenFilters').addEventListener('click', openFilters);
    document.getElementById('agOpenSort').addEventListener('click', openSort);
  }

  /* ── Alto del header sticky → dónde se pega la barra ────── */
  function syncBarTop() {
    if (!bar) return;
    if (!isMobile()) { bar.style.removeProperty('--ag-bar-top'); return; }
    var header = document.querySelector('.section-header')
              || document.querySelector('sticky-header')
              || document.querySelector('#shopify-section-header')
              || document.querySelector('header.header');
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    if (h > 0) bar.style.setProperty('--ag-bar-top', (h - 1) + 'px');
  }

  /* ── Drawer de filtros ─────────────────────────────────── */
  function buildDrawer() {
    overlay = document.createElement('div');
    overlay.className = 'ag-drawer-overlay';
    document.body.appendChild(overlay);

    drawer = document.createElement('div');
    drawer.className = 'ag-filters-drawer';
    drawer.innerHTML =
      '<div class="ag-drawer-header"><h2>Filtros</h2>' +
      '<button type="button" class="ag-drawer-close" aria-label="Cerrar">&times;</button></div>' +
      '<div class="ag-drawer-body"></div>' +
      '<div class="ag-drawer-footer"><button type="button" class="ag-drawer-see">Ver resultados</button></div>';
    document.body.appendChild(drawer);
    body = drawer.querySelector('.ag-drawer-body');

    drawer.querySelector('.ag-drawer-close').addEventListener('click', closeFilters);
    drawer.querySelector('.ag-drawer-see').addEventListener('click', closeFilters);
    overlay.addEventListener('click', closeFilters);
  }

  function openFilters() {
    clearTimeout(closeTimer);
    if (!placeholder) { placeholder = document.createComment('ag-aside-home'); aside.parentNode.insertBefore(placeholder, aside); }
    body.appendChild(aside);
    drawer.classList.add('open');
    overlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('ag-drawer-open');
  }
  function closeFilters() {
    drawer.classList.remove('open');
    overlay.classList.remove('visible');
    document.body.style.overflow = '';
    document.body.classList.remove('ag-drawer-open');
    closeTimer = setTimeout(moveBack, 650);
  }
  function moveBack() {
    if (placeholder && placeholder.parentNode) placeholder.parentNode.insertBefore(aside, placeholder);
  }

  /* ── Sheet de orden ────────────────────────────────────── */
  function buildSortSheet() {
    sortOverlay = document.createElement('div');
    sortOverlay.className = 'ag-drawer-overlay ag-sort-overlay';
    document.body.appendChild(sortOverlay);

    sheet = document.createElement('div');
    sheet.className = 'ag-sort-sheet';
    sheet.innerHTML =
      '<div class="ag-sort-header"><h3>Ordenar por</h3>' +
      '<button type="button" class="ag-sort-close" aria-label="Cerrar">&times;</button></div>' +
      '<div class="ag-sort-options">' +
      SORT_OPTIONS.map(function (o) {
        return '<button type="button" class="ag-sort-option" data-value="' + o[0] + '">' + o[1] + '</button>';
      }).join('') +
      '</div>';
    document.body.appendChild(sheet);

    sheet.querySelector('.ag-sort-close').addEventListener('click', closeSort);
    sortOverlay.addEventListener('click', closeSort);
    sheet.querySelectorAll('.ag-sort-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        markSortActive();
        closeSort();                         // cierra deslizando primero

        setTimeout(function () {             // aplica el orden tras la animación
          var select = document.getElementById('SortBy');
          if (select) select.value = btn.dataset.value;

          var tagActive = document.querySelectorAll('.ag-tag-checkbox:checked').length > 0;

          if (tagActive) {
            // Con etiqueta: lo maneja el JS de etiquetas (intercepta #SortBy)
            if (select) {
              select.dispatchEvent(new Event('input', { bubbles: true }));
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            // Sin etiqueta: AJAX nativo de Dawn
            var form = select ? select.closest('facet-filters-form') : null;
            if (select) {
              select.dispatchEvent(new Event('input', { bubbles: true }));
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            if (form && typeof form.onSubmitHandler === 'function') {
              var evt = new Event('input', { bubbles: true });
              Object.defineProperty(evt, 'target', { value: select, enumerable: true });
              form.onSubmitHandler(evt);
            }
          }
        }, 350);
      });
    });
  }

  function openSort() {
    markSortActive();
    sheet.classList.add('open');
    sortOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('ag-drawer-open');
  }
  function closeSort() {
    sheet.classList.remove('open');
    sortOverlay.classList.remove('visible');
    document.body.style.overflow = '';
    document.body.classList.remove('ag-drawer-open');
  }
  function markSortActive() {
    var select = document.getElementById('SortBy');
    var val = select ? select.value : '';
    sheet.querySelectorAll('.ag-sort-option').forEach(function (b) {
      b.classList.toggle('active', b.dataset.value === val);
    });
  }

  /* ── Cerrar todo al pasar a escritorio ─────────────────── */
  function forceClosed() {
    drawer.classList.remove('open');
    overlay.classList.remove('visible');
    if (sheet) sheet.classList.remove('open');
    if (sortOverlay) sortOverlay.classList.remove('visible');
    document.body.style.overflow = '';
    document.body.classList.remove('ag-drawer-open');
    moveBack();
  }
})();